<template>
  <div v-if="sitter" class="sitter-details">
    <Breadcrumb :to="formatProfileUrl" :header="breadcrumbHeader" />

    <div class="flex justify-between mt-24 md:mt-48">
      <div class="flex">
        <Avatar :image-url="sitter.photoUrl" :size="AvatarSize.MEGA" :name="sitter.displayName" />
        <div class="sitter-details__stats flex flex-col">
          <h2 class="h3 sitter-details__name">{{ sitter.displayName }}</h2>
          <StarRating :show-count="true" :count="sitter.reviews.totalReviewCount" :average="sitter.reviews.starAggregate" />
          <p class="sm:hidden font-medium mt-12">{{ formatPayRate }}<span class="sitter-details__label">/hr</span></p>
        </div>
      </div>
      <p class="hidden sm:block font-medium mt-12 md:text-m2 md:mt-8">
        {{ formatPayRate }}<span class="sitter-details__label">/hr</span>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { mapGetters } from 'vuex';
import Avatar, { AvatarSize } from '@/components/avatar/Avatar.vue';
import Breadcrumb from '@/components/breadcrumb/Breadcrumb.vue';
import StarRating from '@/components/star_rating/StarRating.vue';
import getProviderProfileUrl from '@/helpers/providerProfileUrl';

export default {
  name: 'SitterDetails',
  components: {
    Avatar,
    Breadcrumb,
    StarRating,
  },
  data() {
    return {
      AvatarSize,
    };
  },
  computed: {
    ...mapGetters('interviewRequest', ['sitter']),
    formatProfileUrl(): string {
      const sitterId = (this as any).sitter?.id;
      return (
        getProviderProfileUrl(sitterId, null, (this as any).sitter?.providerType) ||
        getProviderProfileUrl(sitterId, 'babysitter') ||
        ''
      );
    },
    breadcrumbHeader(): string {
      return `${(this as any).sitter?.displayName}'s profile`;
    },
    formatPayRate(): string {
      const min = (this as any).sitter?.profiles?.babysitter?.profile?.payRate?.min;
      const max = (this as any).sitter?.profiles?.babysitter?.profile?.payRate?.max;
      if (min == null || max == null) return '';
      return `$${min / 100}-${max / 100}`;
    },
  },
};
</script>
